import { render, staticRenderFns } from "./ActivitiesOverviewLoyaltyRewards.vue?vue&type=template&id=c0193d40&scoped=true&"
import script from "./ActivitiesOverviewLoyaltyRewards.vue?vue&type=script&lang=ts&"
export * from "./ActivitiesOverviewLoyaltyRewards.vue?vue&type=script&lang=ts&"
import style0 from "./ActivitiesOverviewLoyaltyRewards.vue?vue&type=style&index=0&id=c0193d40&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0193d40",
  null
  
)

export default component.exports